<template>
    <!-- {{ props?.one }} -->
    <p v-if="props?.one?.type === 'DIAGNOSTIC'" class="full-width flex">
        <span class="passage">진단평가</span>
    </p>

    <!-- <div class="panel__box"> -->
    <div v-if="props?.one?.type !== 'DIAGNOSTIC'" class="full-width flex align-center justify-between">
        <template v-for="e in props.one.list" :key="e">
            <p class="flex align-center">
                <span class="level">{{ e.level }} {{ e.passageNumber }}</span>
                <span class="passage">수능모의평가</span>
            </p>
        </template>
    </div>
    <!-- </div> -->

    <!-- <div align="left">
        <span v-if="isSATandRESET" class="mapBoxTtLevles mg_left_0">{{ props.one.level }} {{ props.one.passageNumber }}</span>
        <div v-if="isSATandRESET" class="barVertical" />
         <span v-if="isSATandRESET" class="mapBoxTtMoon">수능모의평가</span>
        <span v-if="!isSATandRESET" class="mapBoxTtMoon mg_left_0">진단평가</span>
          </div> -->
</template>
<script setup>
import { onMounted, computed, ref, watch, defineProps } from 'vue';
// {
//             “level”: “1 레벨“,
//             “passageNumber”: “1회차“,
//             “redirectKey”: 3040
//           }
const props = defineProps({
    // type: {
    //     Type: Object,
    //     required: true,
    // },
    one: {
        Type: Object,
        required: true,
    },
});

const isSATandRESET = computed(() => {
    return props.type === 'SAT' || props.type === 'SAT_RESET';
});
// watch(props.kind, (newProps, oldProps) => {
//     console.log('--watch-props-newProps', newProps);
//     console.log('--watch-props-oldProps', oldProps);
// });

// const kind = computed(() => props.kind);

onMounted(() => {
    // console.log('--one-props-', props.one);
});
////////////////////////////----OnClick----////////////////////////////
// const onMㄴㅇㄹㅇㄴㄹㄴㅇㄹInfo = () => {};
</script>

<style scoped lang="scss"></style>
